export default __webpack_public_path__ + "resources/icons/n103-699f.webp";